"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCatalogProgress = void 0;
const react_1 = require("react");
const react_2 = require("@apollo/client/react");
const get_catalog_query_1 = require("./get-catalog.query");
const client_utils_1 = require("../client.utils");
const useCatalogProgress = ({ catalogId, }) => {
    const [getCatalogByIdMutation, { data, error, },] = (0, react_2.useLazyQuery)(get_catalog_query_1.GET_CATALOG_BY_ID, { notifyOnNetworkStatusChange: true });
    const inFlightCatalogRequest = (0, react_1.useRef)(false);
    const getCatalogById = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        var _a;
        if (!catalogId || inFlightCatalogRequest.current) {
            return null;
        }
        inFlightCatalogRequest.current = true;
        try {
            const getCatalogByIdResponse = yield getCatalogByIdMutation({
                variables: { ids: [catalogId] },
            });
            (0, client_utils_1.genericGraphQLErrorsHandler)(getCatalogByIdResponse);
            return (_a = getCatalogByIdResponse.data.catalogs.edges[0]) === null || _a === void 0 ? void 0 : _a.node;
        }
        catch (_e) { /* empty */
            return null;
        }
        finally {
            inFlightCatalogRequest.current = false;
        }
    }), [getCatalogByIdMutation, catalogId]);
    const catalog = (0, react_1.useMemo)(() => {
        var _a, _b;
        if (!catalogId) {
            return null;
        }
        const currentCatalog = (_b = (_a = data === null || data === void 0 ? void 0 : data.catalogs) === null || _a === void 0 ? void 0 : _a.edges[0]) === null || _b === void 0 ? void 0 : _b.node;
        if (!currentCatalog) {
            return null;
        }
        return currentCatalog;
    }, [data, catalogId]);
    const selectedTags = (0, react_1.useMemo)(() => catalog === null || catalog === void 0 ? void 0 : catalog.tags.edges.map(({ node }) => (node)), [catalog]);
    return {
        getCatalogById,
        inFlightCatalogRequest,
        catalog,
        selectedTags,
        error,
    };
};
exports.useCatalogProgress = useCatalogProgress;
exports.default = exports.useCatalogProgress;
